import styled from "styled-components";
import { Wrapper } from 'AppReact';

export const template = styled.span`
  position: absolute;
  z-index: 9;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background: #D2D2D2;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 12px;
  opacity: 0.5;
`;

export default Wrapper(template);
